export default __webpack_public_path__ + "4f66c4b998bc80c142d9a1e6820611a0.png";